export default "__VITE_ASSET__bb50d738__"